var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quiz__nav quiz__nav_results",staticStyle:{"position":"relative"}},[_c('button',{staticClass:"quiz__nav-btn",on:{"click":_vm.addAllToBag}},[_vm._v("ADD ALL TO BAG")]),_vm._v(" "),_c('a',{staticClass:"quiz__restart-btn",on:{"click":_vm.goToBeginning}},[_vm._v("START OVER")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68f891c0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/app/components/results-ctas.vue
// module id = 50
// module chunks = 0